import React, { useContext, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { motion, useAnimation, useReducedMotion } from 'framer-motion'
import Header from '../header/header'
import Footer from '../footer/footer'
import ScrollProgress from '../ScrollProgress/ScrollProgress'
import ConversionBar from '../ConversionBar/ConversionBar'
import ExitIntent from '../ExitIntent/ExitIntent'
import ScrollTopButton from '../ScrollTopButton/ScrollTopButton'
import CookieBanner from '../CookieBanner/CookieBanner'
import { LanguageContext } from '../LanguageSwitcher/LanguageContext'
import useEntryMotion from '../motion/useEntryMotion'
import { useAnalyticsLoader } from '../../lib/track'

const Layout = ({ children }) => {
  const location = useLocation()
  const { selectedLanguage } = useContext(LanguageContext)
  const reduced = useReducedMotion()
  const animateIn = useEntryMotion()
  const langControls = useAnimation()
  useAnalyticsLoader()
  const firstRender = useRef(true)

  // Switching language swaps a lot of copy at once, which otherwise just
  // "pops". This fades the page out and back in — deliberately without
  // remounting, so the visitor keeps their scroll position and form input.
  //
  // Opacity only, on purpose: a lingering `filter` or `transform` on this
  // wrapper would make it the containing block for its descendants and
  // interfere with the sticky demo reel further down the homepage.
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false
      return
    }
    if (reduced) return
    langControls.start({
      opacity: [0.2, 1],
      transition: { duration: 0.5, ease: [0.22, 1, 0.36, 1] },
    })
  }, [selectedLanguage, langControls, reduced])

  return (
    <div>
      <ScrollProgress />
      <Header />
      <motion.main
        key={location.pathname}
        initial={animateIn ? { opacity: 0, y: 14 } : false}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      >
        <motion.div animate={langControls}>{children}</motion.div>
      </motion.main>
      <Footer />
      <ConversionBar />
      <ScrollTopButton />
      <ExitIntent />
      <CookieBanner />
    </div>
  )
}

export default Layout
